import React from "react";
import ArticleForm from "../components/ArticleForm";
import { COLLECTIONS } from "../utils/cmsSchema";

export default function NewsForm() {
  return (
    <ArticleForm
      schema={COLLECTIONS.news}
      backLabel="Back to News"
      eyebrowSingular="News Article"
    />
  );
}
